import React from 'react';

export const AboutMeDaShawn = () => {
  
    const paragraphStyle = {
        width: '800px',
        paddingLeft: '350px',
        paddingRight: '350px',
    };

    const imageStyle = {
        width: '150px',
        height: '150px',
        borderRadius: '50%',
        objectFit: 'cover',
        border: '3px solid white',
    };

    return (
        <div>
            <h1>About Me - DaShawn Eason</h1>

            {/* Profile picture */}
            <img
                src="Levi.png"
                alt="DaShawn Eason"
                style={imageStyle}
            />

            {/* About Me Text */}
            <div>
                <p style={paragraphStyle}>
                    Hi! My name is DaShawn Eason and this is my about me page. I’m 21 years old and I’m from Brooklyn, New York. I'm currently an undergraduate student at the University at Buffalo where I’m pursuing a degree in Computer Science. Over the years, I've developed a strong passion for problem-solving and coding, which led me to pursue a career in tech. I’m always eager to learn new things and improve my skills. My goal is to be a person who can contribute to projects that have a positive impact on people’s lives.
                </p>
            </div>

        </div>
    );
};
